<template>
  <tr v-if="user" class="customer-item" style="cursor: pointer" @click="showModal = true">
    <td v-if="selectedBot.theme == 'toa'" class="text-xs-center pa-2">
      <template v-if="$store.state.toapainterpage.includes(selectedBot.pageid)">
        <v-btn
          depressed
          :dark="toastatus(user.painter_status) != 'None'"
          :disabled="toastatus(user.painter_status) == 'None'"
          :color="toatstatuscolor(user.painter_status)"
          @click.stop="showtoadialog = true"
          >{{ toastatus(user.painter_status) }}</v-btn
        >
        <v-dialog v-if="showtoadialog" v-model="showtoadialog" width="700px">
          <v-card>
            <v-card-text>
              <toa-painter-info
                v-model="user"
                :user="user"
                @close="showtoadialog = false"
                @updateUserToa="updateUserToa"
              ></toa-painter-info>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
      <template v-else>
        <v-btn
          depressed
          dark
          :color="toatstatuscolor(user.dealer_status)"
          @click.stop="showtoadialog = true"
          >{{ toastatus(user.dealer_status) }}</v-btn
        >
        <v-dialog v-if="showtoadialog" v-model="showtoadialog" width="700px">
          <v-card>
            <v-card-text>
              <toa-approve
                :user="user"
                @close="showtoadialog = false"
                @updateUserToa="updateUserToa"
              ></toa-approve>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
    </td>
    <td v-if="selectedBot.theme == 'hafele'">{{ user.emp_id }}</td>
    <td>
      <v-avatar size="30">
        <img
          v-if="user.profile_pic"
          :src="user.profile_pic"
          width="30"
          height="30"
          :alt="user.first_name + ' ' + user.last_name"
          @error="onFailLoad"
        />
        <img
          v-else
          :src="'/static/img/assets/livechat/profile.png'"
          width="30"
          height="30"
          :alt="user.first_name + ' ' + user.last_name"
        />
      </v-avatar>
    </td>
    <td v-if="selectedBot.type == 'yasale'">
      {{ user.json_variable.memberId ? user.json_variable.memberId : '-' }}
    </td>
    <td v-if="selectedBot.type == 'yasale'" style="min-width: 200px">
      {{ (user.shopname ? user.shopname : '-') | truncate(35) }}
    </td>
    <td v-if="selectedBot.type == 'yasale'" style="min-width: 200px">
      {{ (user.shopprovince ? user.shopprovince : '-') | truncate(35) }}
    </td>
    <td
      v-if="selectedBot.theme == 'sahapan'"
      style="min-width: 300px"
      :title="user.realname ? user.realname : ''"
    >
      <div style="display: inline-block; vertical-align: top; margin-top: 5px">
        {{ (user.realname ? user.realname : '-') | truncate(35) }}
      </div>
    </td>
    <td
      style="min-width: 300px"
      :title="
        (user.first_name ? user.first_name : '') + ' ' + (user.last_name ? user.last_name : '')
      "
    >
      <div style="display: inline-block; vertical-align: top; margin-top: 5px">
        {{
          ((user.first_name ? user.first_name : '') + ' ' + (user.last_name ? user.last_name : ''))
            | truncate(35)
        }}
      </div>
    </td>

    <td v-if="isDelta && user.warranty_status">
      <v-chip color="#0087dc" style="color: white">Registered</v-chip>
    </td>
    <td v-else-if="isDelta && !user.warranty_status">-</td>
    <td v-if="isDelta && user.booking_status">
      <v-chip color="#e52b67" style="color: white">Booked</v-chip>
    </td>
    <td v-else-if="isDelta && !user.booking_status">-</td>
    <td v-if="selectedBot.theme == 'aira'">{{ user.aira_id || '-' }}</td>
    <td v-if="selectedBot.type == 'jamsai'">
      {{ user.roomid ? user.roomid : '-' }}
    </td>
    <template v-if="selectedBot.type == 'summithr'">
      <td>{{ user.member_status ? user.member_status : '-' }}</td>
    </template>
    <template v-if="selectedBot.theme == 'scgdistribution'">
      <td>
        <div>
          {{ user.cardnumber ? user.cardnumber : '-' }}
        </div>
      </td>
      <td style="min-width: 300px">
        <div>
          {{ user.realname ? user.realname : '-' }}
        </div>
      </td>
      <td>
        <div>
          {{ user.address ? user.address : '-' }}
        </div>
      </td>
    </template>
    <td v-if="selectedBot.theme == 'toa'" style="min-width: 300px">
      <div style="display: inline-block; vertical-align: top; margin-top: 5px">
        {{ user.shop_id ? user.shop_id : '-' }}
      </div>
    </td>
    <td v-if="isRatchthani" :title="user.realname ? user.realname : ''">
      <div style="display: inline-block; vertical-align: top; margin-top: 5px">
        {{ (user.realname ? user.realname : '-') | truncate(35) }}
      </div>
    </td>
    <td class="text-xs-center">
      <ChannelLabel :channel="user.app" />
    </td>
    <template v-if="![...$store.state.lamyPage].includes(selectedBot.pageid)">
      <!-- isn't Lamy -->
      <td>{{ user.gender ? $t(user.gender) : '-' }}</td>
    </template>
    <template v-if="selectedBot.type == 'nextcapital'">
      <td>{{ user.login_timestamp ? getFormatDate(user.login_timestamp, 'DD/MM/YYYY') : '-' }}</td>
    </template>
    <!-- end isn't Lamy -->
    <td v-if="$store.state.niveapage.includes(selectedBot.pageid)">
      {{ user.usermessages ? $t(user.usermessages) : '-' }}
    </td>

    <td class="text-xs-center">
      {{ registerTimestamp }}
    </td>
    <td class="text-xs-center">
      {{ lastTimestamp }}
    </td>
    <td v-if="isDDProperty" class="text-xs-center">
      {{ getTimeDiff(user.timestamp) | numberFormat }}
    </td>

    <template v-if="[...$store.state.lamyPage].includes(selectedBot.pageid)">
      <!-- is Lamy -->
      <td class="text-xs-center">{{ user.member_type }}</td>
      <td class="text-xs-center">{{ user.total_purchase | numberFormat }}</td>
      <td class="text-xs-center">{{ user.tags }}</td>
      <td class="text-xs-center">{{ user.memberstatus }}</td>
    </template>
    <template v-else>
      <template v-if="['veranda_new', 'verso'].includes(selectedBot.theme)">
        <td class="text-xs-center">
          {{ handleGetSatisfactionData(user.feedback, 'score') }}
        </td>
        <td class="text-xs-center">
          {{ handleGetSatisfactionData(user.feedback, 'feedback') }}
        </td>
      </template>
      <!-- isn't Lamy -->
      <td :class="{ 'background-gray': $store.getters.getPackage != 'premium' || isCoachlab }">
        <customer-item-value
          v-if="selectedBot.theme == 'scgworkplace'"
          :value="workplaceEmail ? workplaceEmail : user['email']"
          >{{ workplaceEmail ? workplaceEmail : user.email }}</customer-item-value
        >
        <customer-item-value v-else :value="user['email']">{{ user.email }}</customer-item-value>
      </td>
      <td :class="{ 'background-gray': $store.getters.getPackage != 'premium' || isCoachlab }">
        <customer-item-value :value="user['phoneno']">{{ user.phoneno }}</customer-item-value>
      </td>
      <td :class="{ 'background-gray': $store.getters.getPackage != 'premium' || isCoachlab }">
        <customer-item-value v-if="selectedBot.type == 'root'" :value="user['company_name']">{{
          user.company_name
        }}</customer-item-value>
        <customer-item-value v-else :value="user['status']">{{ user.status }}</customer-item-value>
      </td>
      <td class="text-xs-center" style="white-space: nowrap">
        <template v-if="userLocale">
          <flag :iso="userLocale.icon" />
        </template>
        <template v-else>-</template>
      </td>
      <td v-if="isBU">
        <customer-item-value :value="user['lineid']">{{ user.lineid }}</customer-item-value>
      </td>
      <td v-if="isBU">
        <customer-item-value :value="user['province']">{{ user.province }}</customer-item-value>
      </td>
      <td v-if="isBU">
        <customer-item-value :value="user['school']">{{ user.school }}</customer-item-value>
      </td>
      <td style="white-space: nowrap">
        <v-btn
          v-if="selectedBot && selectedBot.type == 'nestle'"
          outline
          icon
          small
          @click.stop="showTagsTimestamp = true"
        >
          <v-icon>more_horiz</v-icon>
        </v-btn>
        <v-btn outline fab small class="extra-small">
          <em class="fas fa-align-left" />
        </v-btn>
        <!-- <a href="javascript:void(0)" class="btn btn-primary transparent btn-sm" style="margin-right: 5px; margin-bottom: 5px;"><em class="fab fa-facebook-messenger"/> Chat</a> -->
      </td>
    </template>
    <!-- end isn't Lamy -->

    <v-dialog v-model="showModal" width="800" persistent>
      <v-card>
        <v-tabs
          v-if="selectedBot.theme == 'scgworkplace'"
          v-model="workplacetab"
          color="white"
          :slider-color="$vuetify.theme.primary"
        >
          <v-tab :key="'Info'" ripple :href="'#Info'">{{ $t('Info') }}</v-tab>
          <v-tab :key="'Workplace'" ripple :href="'#Workplace'">{{ $t('Workplace') }}</v-tab>
        </v-tabs>
        <div v-if="selectedBot.theme == 'scgworkplace' && workplacetab == 'Workplace'">
          <WorkplaceCustomer v-if="showModal" :key="user.id" v-model="user.id">
            <div slot="header" class="text-xs-right">
              <v-btn flat fab small class="extra-small" @click="showModal = false">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </WorkplaceCustomer>
        </div>
        <div
          v-else-if="
            selectedBot.theme == 'ticket' ||
            $store.state.ticketPageid.includes(selectedBot.pageid) ||
            $store.state.ticketThemeList.includes(selectedBot.theme)
          "
        >
          <TicketCustomerDetail v-if="showModal" :key="user.id" v-model="user.id">
            <div slot="header" class="text-xs-right">
              <v-btn flat fab small class="extra-small" @click="showModal = false">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </TicketCustomerDetail>
        </div>
        <div v-else>
          <customer-detail v-if="showModal" :key="user.id" v-model="user.id" :gender.sync="user">
            <div slot="header" class="text-xs-right">
              <v-btn flat fab small class="extra-small" @click="showModal = false">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </customer-detail>
        </div>

        <v-card-text class="text-xs-center">
          <v-btn outline color="grey" @click="showModal = false">{{ $t('cancel') }}</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <NestleTagsTimestamp v-if="showTagsTimestamp" v-model="showTagsTimestamp" :user="user" />
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import config from '@/config'
import CustomerItemValue from './CustomerItemValue'
import api from '@/api'
import CustomerDetail from './CustomerDetail.vue'
import TicketCustomerDetail from './../TicketCustomerDetail.vue'
import WorkplaceCustomer from '@/components/view/livechat/scgworkplace-customer.vue'
import ToaApprove from '../customize/ToaApprove.vue'
import ToaPainterInfo from './../customize/ToaPainterInfo.vue'
import NestleTagsTimestamp from './../customize/NestleTagsTimestamp'
import ChannelLabel from '@/components/elements/ChannelLabel.vue'
import { PAGE } from '@/constants/page.js'

export default {
  components: {
    CustomerItemValue,
    CustomerDetail,
    WorkplaceCustomer,
    ToaApprove,
    ToaPainterInfo,
    TicketCustomerDetail,
    NestleTagsTimestamp,
    ChannelLabel
  },
  props: ['value'],
  data: function () {
    return {
      showtoadialog: false,
      user: undefined,
      showModal: false,
      showAllIntent: false,
      isEditTag: false,
      usertag: '',
      workplacetab: 'Workplace',
      showTagsTimestamp: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab'
    }),
    registerTimestamp() {
      return this.user.registertimestamp
        ? this.getFormatDate(
            this.user.registertimestamp,
            this.isDDProperty ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'
          )
        : '-'
    },
    lastTimestamp() {
      return this.user.timestamp
        ? this.getFormatDate(
            this.user.timestamp,
            this.isDDProperty ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'
          )
        : '-'
    },
    isDDProperty() {
      if (this.selectedBot) {
        if (PAGE.DDPROPERTY.includes(this.selectedBot.pageid)) {
          return true
        }
      }
      return false
    },
    workplaceEmail() {
      var data = null
      if (this.value && this.value.sessionvalue) {
        try {
          data = JSON.parse(this.value.sessionvalue)
        } catch (error) {
          data = null
        }
        return data.mail ? data.mail : ''
      } else {
        return ''
      }
    },
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    },
    filterIntent: function () {
      var vm = this
      return vm.user.intentlist.sort(function (a, b) {
        if (parseInt(a[1]) > parseInt(b[1])) {
          return -1
        }

        if (parseInt(a[1]) < parseInt(b[1])) {
          return 1
        }

        return 0
      })
    },
    userLocale: function () {
      var vm = this
      return config.locale.find(function (locale) {
        if (vm.user.locale == locale.value) {
          return locale.title
        }
      })
    },
    tags: function () {
      var vm = this
      if (vm.user.tags !== '' && vm.user.tags != null) {
        var usertags = vm.user.tags.split(',')
        return usertags
      } else {
        return []
      }
    },
    usertags: {
      get() {
        let vm = this
        if (vm.user && vm.user.tags && vm.user.tags !== '') {
          var usertags = []

          usertags = vm.user.tags.split(',')
          var result = []
          if (usertags) {
            usertags.map(function (tag) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (tag) {
            result.push(tag.text)
          })
        }
        vm.user.tags = result.join(',')
      }
    },
    isRatchthani() {
      return PAGE.RATCHTHANI.includes(this.selectedBot.pageid)
    },
    isDelta() {
      return PAGE.DELTA.includes(this.selectedBot.pageid)
    }
  },
  watch: {
    value: function () {
      this.user = this.value
    }
  },
  mounted: function () {
    this.user = this.value
    this.cached_tag = this.user.tags
    if (this.user.json_variable) {
      try {
        Object.assign(this.user, JSON.parse(this.user.json_variable))
      } catch (error) {
        console.error(error)
      }
    }
  },
  methods: {
    getTimeDiff() {
      const registertimestamp = moment(this.user.registertimestamp)
      const timestamp = moment(this.user.timestamp)
      const seconds = timestamp.diff(registertimestamp, 'seconds')
      return seconds > 0 ? seconds : 0
    },
    toatstatuscolor(status) {
      if (status == 'waiting for approval') return '#fb8c00'
      else if (status == 'approve') return 'green'
      else return 'rgb(201 201 201)'
    },
    toastatus(status) {
      if (status == 'waiting for approval') return 'Waiting'
      else if (status == 'approve') return 'Approved'
      else return 'None'
    },
    updateUserToa(payload) {
      this.user = payload
    },
    saveEditTag: function () {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        usersid: vm.user.id,
        tags: vm.user.tags || ''
      }
      api.saveUserTags(data, function (error) {
        if (error) {
          console.error(error)
        }
        vm.cached_tag = vm.user.tags
        vm.isEditTag = false
      })
    },
    cancelEditTag: function () {
      this.user.tags = this.cached_tag
      this.isEditTag = false
    },
    onFailLoad: function () {
      this.$set(this.user, 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getFormatDate: function (date, format) {
      return moment(date).format(format)
    },
    addUserTags: function (newTags) {
      this.usertags = newTags
    },
    checkUserTags(obj) {
      this.errorTag = []
      // if (obj.tag.text.length > 25) {
      //   this.errorTag.push('overmaxlength')
      //   obj.error()
      // } else

      if (obj.tag.isDuplicate) {
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    onEditStatus: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        status: payload.customer_value || ''
      }
      api.saveUserStatus(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditEmail: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        email: payload.customer_value || ''
      }
      api.saveUserEmail(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditPhone: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        phoneno: payload.customer_value || ''
      }
      api.saveUserPhoneno(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    handleGetSatisfactionData(value, column) {
      if (value) {
        const splitData = value.split('-')
        const score = splitData[0] || '-'
        const feedback = splitData[1] || '-'

        return column === 'score' ? score : column === 'feedback' ? feedback : '-'
      } else {
        return '-'
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customer/CustomerItem.vue